<script lang="ts" setup>
import {onBeforeMount, ref} from "vue";

const props = defineProps({
  value: {type: Boolean, required: true},
});
const emit = defineEmits<{
  (e: "input", value: boolean): void,
  (e: "update-available"): void,
}>();
const dontUpdateOnClick = () => {
  emit("input", false);
  document.dispatchEvent(new CustomEvent("ignore-update-service-worker"));
};
const updating = ref(false);
const updateNowOnClick = () => {
  updating.value = true;
  document.dispatchEvent(new CustomEvent("activate-service-worker"));
};

onBeforeMount(() => {
  document.addEventListener("service-worker-installed", () => {
    emit("update-available");
  });
});
</script>

<template>
  <v-snackbar
    id="new-version-notification"
    :value="props.value"
    centered
    color="grey lighten-1"
    elevation="1"
    outlined
    timeout="-1"
    top
    transition="slide-x-reverse-transition"
    vertical
  >
    <div class="black--text">
      <v-icon
        color="primary"
        left
        x-large
      >
        mdi-download
      </v-icon>
      <strong>New version</strong> of Sentec PMS is available!
    </div>
    <template #action="{ attrs }">
      <v-btn
        class="mr-1 pl-2 pr-2"
        plain
        text
        @click="dontUpdateOnClick"
        v-show="!updating"
      >
        Don't Update
      </v-btn>
      <v-btn
        class="pl-2 pr-2"
        color="primary"
        v-bind="attrs"
        @click="updateNowOnClick"
        :loading="updating"
      >
        Update Now
        <v-icon right>
          mdi-update
        </v-icon>
        <template #loader>
          Updating...
          <span class="custom-loader ml-1">
            <v-icon
              color="white"
            >mdi-autorenew</v-icon>
          </span>
        </template>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<style>
#new-version-notification .v-snack__wrapper {
  border: 0.5px solid;
}
</style>
